import React from 'react';
import { connect } from 'react-redux';

const BalanceDetailsPage = () => {
    return (
        <div className="balance-details-page">
            <div>Balance Details</div>
        </div>
    );
}

export default connect()(BalanceDetailsPage);
